module.exports = __webpack_public_path__ + "img/Greece.3f936450.png";